import { render, staticRenderFns } from "./StatsPhoenixPartners.vue?vue&type=template&id=6ff3d4b5&"
import script from "./StatsPhoenixPartners.vue?vue&type=script&lang=js&"
export * from "./StatsPhoenixPartners.vue?vue&type=script&lang=js&"
import style0 from "./StatsPhoenixPartners.vue?vue&type=style&index=0&id=6ff3d4b5&prod&lang=scss&"
import style1 from "./StatsPhoenixPartners.vue?vue&type=style&index=1&id=6ff3d4b5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports